import {
  type GraphQLVolunteerEvent,
  GraphQLVolunteerStatus,
} from '@sola/schema/dotcom/supporters/schema.generated.ts';

import { MOCK_SUPPORTER_CONTACTS } from './contacts.ts';

export const MOCK_SUPPORTER_VOLUNTEER_EVENTS: GraphQLVolunteerEvent[] = [
  {
    description:
      'The Compassion Experience is a mobile, immersive journey through a child’s story of overcoming poverty.',
    endDate: '2026-08-17T20:30:00',
    id: '701PW000018SzeYYAS',
    locationName: 'Compassion Experience at Grace Christian Fellowship',
    slots: [
      {
        contactId: MOCK_SUPPORTER_CONTACTS[0].id,
        endDate: '2026-08-15T14:30:00',
        id: 'a1DPW00000AX6oz201',
        isWaiverComplete: false,
        shiftName: 'Compassion Experience Volunteer',
        startDate: '2026-08-15T09:30:00',
        status: GraphQLVolunteerStatus.Pending,
      },
      {
        contactId: MOCK_SUPPORTER_CONTACTS[1].id,
        endDate: '2026-08-15T14:30:00',
        id: 'a1DPW00000AX6oz202',
        isWaiverComplete: false,
        shiftName: 'Compassion Experience Volunteer',
        startDate: '2026-08-15T09:30:00',
        status: GraphQLVolunteerStatus.Pending,
      },
    ],
    startDate: '2026-08-14T17:00:00',
    venue: {
      address1: '1250 Fisher Ave',
      city: 'Cortland',
      country: 'United States',
      name: 'Grace Christian Fellowship',
      postalCode: '13045',
      state: 'NY',
    },
  },
  {
    description: 'Volunteer at The Thorn Tour in Inglewood.',
    endDate: '2026-10-22T20:30:00',
    id: 'mock-event-1',
    locationName: 'The Thorn Tour',
    slots: [
      {
        contactId: MOCK_SUPPORTER_CONTACTS[0].id,
        endDate: '2026-10-22T18:00:00',
        id: 'the-thorn-tour-entrance-host',
        isWaiverComplete: false,
        shiftName: 'Entrance Host',
        startDate: '2026-10-22T17:00:00',
        status: GraphQLVolunteerStatus.Pending,
      },
      {
        contactId: MOCK_SUPPORTER_CONTACTS[0].id,
        endDate: '2026-10-22T19:00:00',
        id: 'the-thorn-tour-setup',
        isWaiverComplete: false,
        shiftName: 'Set Up Volunteer',
        startDate: '2026-10-22T18:00:00',
        status: GraphQLVolunteerStatus.Pending,
      },
      {
        contactId: MOCK_SUPPORTER_CONTACTS[1].id,
        endDate: '2026-10-22T19:00:00',
        id: 'the-thorn-tour-setup-sarah',
        isWaiverComplete: false,
        shiftName: 'Set Up Volunteer',
        startDate: '2026-10-22T18:00:00',
        status: GraphQLVolunteerStatus.Pending,
      },
      {
        contactId: MOCK_SUPPORTER_CONTACTS[1].id,
        endDate: '2026-10-22T20:30:00',
        id: 'the-thorn-tour-teardown',
        isWaiverComplete: false,
        shiftName: 'Tear Down Volunteer',
        startDate: '2026-10-22T19:00:00',
        status: GraphQLVolunteerStatus.Pending,
      },
    ],
    startDate: '2026-10-22T17:00:00',
    venue: {
      address1: '1011 Stadium Dr',
      city: 'Inglewood',
      country: 'United States',
      name: 'YouTube Theater',
      postalCode: '90305',
      state: 'CA',
    },
  },
  {
    description: 'Volunteer at Ezekiel Azonwu Spring Forward.',
    endDate: '2026-11-21T20:00:00',
    id: 'mock-event-2',
    locationName: 'Ezekiel Azonwu Spring Forward',
    slots: [
      {
        contactId: MOCK_SUPPORTER_CONTACTS[0].id,
        endDate: '2026-11-20T20:00:00',
        id: 'spring-forward-friday-teardown',
        isWaiverComplete: true,
        shiftName: 'Tear Down Volunteer',
        startDate: '2026-11-20T18:30:00',
        status: GraphQLVolunteerStatus.Approved,
      },
      {
        contactId: MOCK_SUPPORTER_CONTACTS[0].id,
        endDate: '2026-11-21T20:00:00',
        id: 'spring-forward-saturday-teardown',
        isWaiverComplete: true,
        shiftName: 'Tear Down Volunteer',
        startDate: '2026-11-21T18:30:00',
        status: GraphQLVolunteerStatus.Approved,
      },
    ],
    startDate: '2026-11-20T18:30:00',
    venue: {
      address1: '1011 Stadium Dr',
      city: 'Inglewood',
      country: 'United States',
      name: 'YouTube Theater',
      postalCode: '90305',
      state: 'CA',
    },
  },
];
